/**
 * Contact Email Configuration
 * 
 * Centralized location for all contact email addresses used throughout the application.
 * Update these values to change contact information across the entire platform.
 */

export const CONTACT_EMAILS = {
  /**
   * Primary support and contact email - shown to users in UI
   */
  support: 'adrien@voluntaselevate.com',

  /**
   * Crash / bug reports from the in-app error page (opens the user's mail client)
   */
  bugs: 'freddy@fieldporter.com',
  
  /**
   * Admin contact email
   */
  admin: 'adrien@voluntaselevate.com',
  
  /**
   * No-reply email for automated system notifications
   */
  noreply: 'noreply@voluntaselevate.com',
  
  /**
   * Team email for general inquiries
   */
  team: 'adrien@voluntaselevate.com',
} as const;

/**
 * Contact URLs
 */
export const CONTACT_URLS = {
  website: 'https://voluntas.group/',
  appBase: 'https://app.voluntas.com',
} as const;

/**
 * Email subjects for common use cases
 */
export const EMAIL_SUBJECTS = {
  applicationInquiry: 'Application Status Inquiry',
  supportRequest: 'Support Request',
  generalInquiry: 'General Inquiry',
  bugReport: 'Voluntas app error',
} as const;

